import React from 'react';
import { Container, Title, Text } from '@mantine/core';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const Home = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  return (
    <Container size="md" py="xl">
      <Title order={1}>Welcome to Owlara Platform</Title>
      {user && (
        <Text mt="md">
          Hello, {user.displayName}!
        </Text>
      )}
    </Container>
  );
};

export default Home; 